import { render } from "./CorrectionList.vue?vue&type=template&id=a70a6774&scoped=true"
import script from "./CorrectionList.vue?vue&type=script&lang=js"
export * from "./CorrectionList.vue?vue&type=script&lang=js"

import "./CorrectionList.vue?vue&type=style&index=0&id=a70a6774&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-a70a6774"]])

export default __exports__